module.exports = __webpack_public_path__ + "static/media/cash-flow.28c41164.svg";